import React, { useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  margin-left: 6px;
`;

const BorderContainer = styled.div`
  padding: 6px 6px 6px 0px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  transition: all 0.2s;
`;

const PriceField = styled.input`
  height: 100%;
  border-radius: 6px;
  outline: none;
  padding: 0px 13px;
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  transition: all 0.2s;
  font-size: 15px;
`;

const CurrencyLabel = styled.div`
  padding: 10px 13px;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  border-left: 1px solid #e3e4e5;
  border-top: 1px solid #e3e4e5;
  border-bottom: 1px solid #e3e4e5;
  color: #525067;
  margin: 6px 0px;
`;

type Props = {
  value: number | undefined;
  onChange: (value: number) => void;
  currency: string; // The currency code in ISO 4217 format.
};

const toCurrencyCharacter = (code: string) => {
  switch (code) {
    case 'eur':
      return '€';
    case 'gbp':
      return '£';
    case 'usd':
      return '$';
    default:
      return code;
  }
};
function PriceInput({ value, currency, onChange }: Props) {
  const [focused, setFocused] = useState(false);

  const currencyChar = toCurrencyCharacter(currency);
  return (
    <Container>
      <CurrencyLabel>{currencyChar}</CurrencyLabel>
      <BorderContainer
        style={{ background: focused ? '#f6f6ff' : 'transparent' }}
      >
        <PriceField
          type='number'
          style={{
            border: focused ? '1px solid #AEB1FC' : '1px solid #e3e4e5',
          }}
          placeholder={`e.g ${currencyChar}1 - ${currencyChar}0.0005`}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onChange={(evt) => {
            if (onChange) onChange(parseFloat(evt.target.value));
          }}
        />
      </BorderContainer>
    </Container>
  );
}

export default PriceInput;
